/**
 * This component intentionally left blank.
 */
export function UserPriceForm() {
  return null;
}
